export var userKinds = {
    customer: 0,
    barber: 1,
    shopOrBrand: 2,
    superAdmin: 3,
    admin: 4,
    agent: 5,
    brand: 6,
};
export var isBrandUser = function (user) {
    return user.kind === userKinds.shopOrBrand && !!user.brandId;
};
export var isShopUser = function (user) {
    return user.kind === userKinds.shopOrBrand && !user.brandId;
};
export var isBarberUser = function (user) {
    return user.kind === userKinds.barber;
};
export var isAdminUser = function (user) {
    return user.kind === userKinds.admin || user.kind === userKinds.superAdmin;
};
export var isAgentUser = function (user) {
    return user.kind === userKinds.agent;
};
